export default "https://cdn-static.gokick.com/assets/1d764bbda6f1db3d5ed96a1ece7edd078534d524/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";